// extracted by mini-css-extract-plugin
export default {"container":"UnorganizedView-module__container--mIdq2","animatedBackground":"UnorganizedView-module__animatedBackground--l1t7L"};